import { GuidedIFCStep } from './types'

/** First non-skipped step index scanning from `from` in `dir`, or -1 if there is none. */
export const findNavigableStep = (steps: GuidedIFCStep[], from: number, dir: 1 | -1): number => {
  for (let i = from; i >= 0 && i < steps.length; i += dir) {
    if (!steps[i]?.skipped) return i
  }
  return -1
}
